<template>
    <div id="bbg" class="beginningbg">
        <div class="beginningimg">
            <img :src="`https://p3.udn.com.tw/wish/images/beginning/beginning_${img}_${selectSrc_3('mob', 'pad', 'pc')}.jpg`" />
            <!--<img :src="`https://p3.udn.com.tw/wish/images/beginning/beginning_education_4_${selectSrc_3('mob', 'pad', 'pc')}.jpg`"/>-->
        </div>
        <div id="beginningtitle" class="beginningtitle">
            <div id="category" class="category">
                {{gettext0}}
            </div>
            <div id="titlepart" class="titlepart">
                <div class="eachtitle">
                    {{gettext1}}
                </div>
                <div class="eachtitle">
                    <div v-if="getwidth && gettextflag" class="dummy_more">我我</div>
                    <div v-else class="dummy">我</div>
                    {{gettext2}}
                </div>
            </div>
        </div>
        <!-- <div class="coverblack">

        </div> -->
        <div class="header-scroll">
            <div class="header-scroll__text">下滑看更多</div>
            <div class="header-scroll__img"></div>
        </div>
    </div>
</template>

<script>
    import {selectSrcMethod_3} from "@/assets/js/utils/masterBuilder.js";
    export default {
        mixins: [selectSrcMethod_3],
        data(){
            return{
            
            }
        },
        props: {
            img: { type: String },
            title: { type: Array },
        },
        created () {
            //window.addEventListener('resize', this.resizeevent);
            window.addEventListener('load', this.loadevent);
        },
        destroyed () {
            //window.removeEventListener('resize', this.resizeevent);
            window.removeEventListener('load', this.loadevent);
        },
        mounted(){
            
        },
        computed:{
            getwidth(){
                if(navigator.userAgent.match(/iPhone/i) || window.innerWidth<768) return false;
                return true;
            },
            gettext0(){
                if(this.title!=undefined) return this.title[0];
                else return "";
            },
            gettext1(){
                if(this.title!=undefined) return this.title[1];
                else return "";
            },
            gettext2(){
                if(this.title!=undefined) return this.title[2];
                else return "";
            },
            gettextflag(){
                if(this.title!=undefined && this.title[1].length>3) return true;
                else return false;
            },
        },
        components: {

        },
        methods:{
            loadevent(){
                window.setTimeout(( () => document.getElementById("bbg").style["height"] = window.innerHeight + "px" ),0);
            },
        },
    }
</script>

<style lang="scss" scoped>
.beginningbg{
    position: relative;
    width: 100%;
    height: 100vh;
    .beginningimg{
        position: relative;
        img{
            width: 100%;
            height: 100vh;
            object-fit: cover;
        }
    }
    .beginningtitle{
        position: absolute;
        top: 64px;
        right: 15px;
        display: flex;
        flex-direction: row-reverse;
        @media (min-width: 414px) AND (max-width: 768px) {
            top: 73.21px;
            right: 20px;
        }
        @media (min-width: 768px) AND (max-width: 960px) {
            top: 86.21px;
            right: 20px;
        }
        @media (min-width: 960px) {
            top: 86.21px;
            right: 80px;
        }
        .category{
            font-size: 20px;
            line-height: 30px;
            color: #A08E33;
            writing-mode: vertical-rl;
            font-family: 'Noto Serif TC';
            font-weight: bold;
            letter-spacing: 7px;
            @media (min-width: 768px) AND (max-width: 960px) {
                font-size: 24px;
                line-height: 34px;
                letter-spacing: 7px;
            }
            @media (min-width: 960px) {
                font-size: 24px;
                line-height: 34px;
                letter-spacing: 10px;
            }
        }
        .titlepart{
            font-size: 32px;
            line-height: 38px;
            color: #F1F1F1;
            writing-mode: vertical-rl;
            display: flex;
            flex-direction: row;
            font-family: 'Noto Serif TC';
            font-weight: bold;
            letter-spacing: 7px;
            @media (min-width: 414px) AND (max-width: 768px) {
                font-size: 36px;
                line-height: 42px;
                flex-direction: row;
            }
            @media (min-width: 768px) AND (max-width: 960px) {
                font-size: 50px;
                line-height: 62.5px;
                flex-direction: row;
            }
            @media (min-width: 960px) {
                font-size: 50px;
                line-height: 62.5px;
                letter-spacing: 10px;
                flex-direction: column;
            }
            .eachtitle{
                .dummy{
                    display: inline-block;
                    color: transparent;
                    font-size: 0px;
                    visibility: hidden;
                    @media (min-width: 960px){
                        font-size: 30px;
                    }
                }
                .dummy_more{
                    display: inline-block;
                    color: transparent;
                    font-size: 40px;
                    visibility: hidden;
                }
            }
        }
    }
    // .coverblack{
    //     position: absolute;
    //     width: 100%;
    //     height: 30vh;
    //     bottom: 0;
    //     background-image: linear-gradient(to top, #1D1C1B , rgba(0, 0, 0, 0) );
    // }
    .header-scroll{
        position: absolute;
        width: 100%;
        bottom: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        .header-scroll__text{
            color: #FAFAFA;
            font-size: 13px;
            line-height: 24px;
            opacity: 0.8;
            margin-bottom: 3px;
            font-family: 'Noto Sans TC';
            font-weight: 300;
            opacity: 0.8;
        }
        .header-scroll__img {
            width: 1px;
            height: 130px;
            background: linear-gradient(to bottom, #BBA01B 0%, rgba(160, 142, 51, 0.8) 10%, rgba(160, 142, 51, 0.2) 100%);
        }
    }
}
</style>